import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ServicePortalApi } from '../../../api/api';
import { SynBreadcrumbComponent, SynBreadcrumbItemComponent } from '@synergy-design-system/angular';
import { TestUserFormComponent } from './test-user-form.component';
import { emptyTestUser } from '../../../api/constants';
import { TestUserInput } from '../../../api/types';
import { getUserData } from '../../../api/auth';
import { handleError, setDuplicateUsernameError } from '../../../errors';

@Component({
  selector: 'app-new-test-user',
  template: `
    <syn-breadcrumb>
      <syn-breadcrumb-item routerLink="" i18n="@@home">Home</syn-breadcrumb-item>
      <syn-breadcrumb-item routerLink="/test-users" i18n="@@test-users">Test Users</syn-breadcrumb-item>
      <syn-breadcrumb-item i18n="@@create-new-test-user">Create New Test User</syn-breadcrumb-item>
    </syn-breadcrumb>

    <h1 i18n="@@create-new-test-user">Create New Test User</h1>

    <app-test-user-form
      [user]="user()!"
      [create]="true"
      submitIcon="add"
      submitText="Create New Test User"
      i18n-submitText="@@create-new-test-user"
      (submitUser)="onSubmit($event)"
    />
  `,
  styles: [],
  imports: [
    RouterLink,
    SynBreadcrumbComponent,
    SynBreadcrumbItemComponent,
    TestUserFormComponent,
  ],
})
export class NewTestUserComponent implements OnInit {
  api = inject(ServicePortalApi);
  router = inject(Router);
  activeRoute = inject(ActivatedRoute);

  user = signal(emptyTestUser());
  application = signal('');

  ngOnInit(): void {
    // Test users are created with the same email address as their creators
    // This way, the email verification is sent the creator by default
    // The email address can later be changed by the owners of the test user
    const currentUser = getUserData();
    const email = currentUser.email ?? '';
    const id = currentUser.id;
    this.user.update((user) => {
      return { ...user, email, owners: [{ id }] };
    });
  }

  onSubmit(input: TestUserInput) {
    this.api.createTestUser(input, (createdUser) => {
        void this.router.navigate(['test-users', createdUser.id]);
      },
      (error) => {
        console.log(error);
        if (error.status === 409) {
          setDuplicateUsernameError();
        } else {
          handleError(error);
        }
      });
  }
}
